import { gql } from "@apollo/client";

export const CREATE_WAREHOUSE = gql`
  mutation CreateWarehouse($input: createWarehouseInput) {
    createWarehouse(input: $input) {
      warehouseId
      warehouseName
      location
      capacity
      managerID
      temperatureControlled
      accessibility
      createdAt
    }
  }
`;






